import styles from './registrations.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { useCourseGetRequestHook } from '../../requestUtils';
import RegistrationGrid from './registration-grid/registration-grid';
import { Box, Container, Icon, Link } from '@frontend-workspace/react-shared-lib';
import { ICourse } from '../../_models/course';
import { IRegistration } from '../../_models/registration';
import RegistrationGridSkeleton from './registration-grid/registration-grid-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface RegistrationProps { }

export function Registration(props: RegistrationProps) {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: course }: { data: ICourse } = useCourseGetRequestHook(`course/get/${courseId}`, undefined);
  const { data: registrations, isLoading, getData: getRegistrations }: { data: IRegistration[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`course/registrations/${courseId}`, undefined);

  const date = course?.date ? new Date(course.date * 1000) : '';
  const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const formattedDate = date ? date.toLocaleString('no-NO', options) : '';
  const handleBackNavigation = () => navigate(`/course-admin/course`);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <Link onClick={handleBackNavigation} className='d-inline-flex mb-3' underline='hover'>
              <Icon className='me-1'>arrow_back</Icon>{t('standard.courseList')}
            </Link>
            <PageTitle title={course ? `${course.courseName}` : "..."} subtitle={formattedDate ? `(${t('registration.courseDate')}: ${formattedDate})` : " (...)"}
            />
            {isLoading ? <RegistrationGridSkeleton /> :
              <RegistrationGrid
                registrations={registrations}
                refreshData={getRegistrations}
              />
            }
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Registration;
